import lessons from './lessons-icon.js'
import progress from './progress-icon.js'
import reviews from './reviews-icon.js'

export default {
  lessons,
  progress,
  reviews
}
